import React from 'react';
import styles from './index.less';

const Index = ({ text, actionText, onClick }) => (
  <div className={styles['setting-row']}>
    <span className={styles['setting-row_text']}>{text}</span>
    <span className={styles['setting-row_action-text']} onClick={onClick}>{actionText}</span>
  </div>
);

export default Index;
